import { connect } from 'react-redux';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Global from '../../../../store/global-selectors';
import * as Actions from '../../../../store/orders/filtering/orders.filtering.actions';
import { orderGridChangePage } from '../../../../store/orders/grid/orders.grid.actions';
import FilterView from '../index';
import messages from '../../messages';

const mapStateToProps = (state, ownProps) => {
  const activeFilterViewId = Global.selectOrdersFilteringActiveFilterViewId(state);
  const displayName = <FormattedMessage {...messages.filterViewAll} />;

  return {
    activeFilterViewId,
    isActive: activeFilterViewId === ownProps.filterViewId,
    displayName,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onViewClick: (filterViewId) => {
      dispatch(orderGridChangePage(1));
      dispatch(Actions.switchActiveFilterView(filterViewId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterView);
